<template>
  <DefaultLayout>
    <div>
      <img v-lazy="getPhoto" class="img-fluid" />
      <div class="text-center">
        <br />
        <h2>{{ getRPSScenario.completion_title }}</h2>
      </div>
      <span v-html="getRPSScenario.completion_description" />
      <br />
      <div class="text-center">
        <div v-if="!disableReportingButton">
          <base-button
            type="primary"
            style="margin: 2px"
            v-on:click="openReporting()"
            >{{ $t("openreporting") }}</base-button
          >
          <br />
          <br />
        </div>
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { updateGameLastPageShown } from "@/services/APIService";
import { mapGetters } from "vuex";
import { convertPhotoToAmazonURL } from "@/services/utils";

export default {
  components: { DefaultLayout, },
  watch: {
    getGameReportingOpen: {
      handler(newData, oldData) {
        this.openReporting();
      },
    },    
  },  
  data: function () {
    return {};
  },
  async created() {
    if (this.$store.getters.getIsFacilitator) {
      updateGameLastPageShown(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        true
      );
    }

    this.$store.dispatch("connectNotification");

    this.$store.dispatch("updateGame");

    this.$store.commit({
      type: "setCurrentCaseNumber",
      currentCaseNumber: this.$store.getters.getNumberOfRPSCases + 1,
    });
  },
  computed: {
    ...mapGetters([
      "getGameReportingOpen",
    ]),
    getPhoto() {
      if (this.getRPSScenario.completion_photo) {
        return convertPhotoToAmazonURL(this.getRPSScenario.completion_photo);
      } else {
        return "/placeholder.png";
      }
    },
    getRPSScenario() {
      return this.$store.getters.getRPSScenarioInCurrentLocale;
    },
    disableReportingButton() {
      return !this.$store.state.main.game.reportingOpen;
    },
  },
  methods: {
    async openReporting() {
      await this.$router.push("/rps/reporting");
    },    
  },
};
</script>

<i18n>
{
  "en": {
    "openreporting": "Open reports"
  },
  "fi": {
    "openreporting": "Avaa raportit"
  },
  "sv": {
    "openreporting": "Öppna rapporterna"
  },
  "de": {
    "openreporting": "Berichte öffnen"
  },
 "ko": {
    "openreporting": "결과보고서 보기"
  }
}
</i18n>
